<a
  *ngIf="isTableDesktopView"
  gtm="onGoToPage"
  gtmAction="Installation"
  gtmCategory="installationsOverview"
  [gtmId]="installation.id"
  class="installation flex flex-row gap-[15px] justify-start items-center"
  [class.border]="isTrialPackageEnding || isContingentPackageEnding"
  [class.installation-spaced]="isMultigatewayInstallation && !installation.isColdSystem"
  routerLink="/installations/{{ installation.id }}"
>
  <div class="flex flex-col">
    <div
      [class.spaced-row]="isMultigatewayInstallation && !installation.isColdSystem"
      class="flex flex-row gap-[15px] justify-start items-center"
    >
      <div *ngIf="!isMultigatewayInstallation" class="flex-[22px] min-w-[22px] max-w-[22px]">
        <app-installation-item-status
          [liveUpdate]="true"
          [gateway]="installation.gateways[0]"
          [isColdSystem]="installation.isColdSystem"
        ></app-installation-item-status>
      </div>

      <div
        *ngIf="isMultigatewayInstallation && installation.isColdSystem"
        class="flex-[22px] min-w-[22px] max-w-[22px]"
      >
        <mat-icon
          [matTooltip]="
            '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.MULTI_GATWAY.COLD_SYSTEM' | translate
          "
          class="cold-system-mode !flex flex-row flex-[20px] min-w-[20px] max-w-[20px] justify-center items-stretch"
          >cancel</mat-icon
        >
      </div>
      <div
        data-at-device
        class="device flex flex-row gap-[20px] flex-[470px] min-w-[470px] max-w-[470px] justify-start items-center"
      >
        <div
          data-at-device-icon
          class="device-icon flex flex-row flex-[55px] min-w-[55px] max-w-[55px] justify-center items-center"
        >
          <div class="flex-1">
            <ng-container *ngIf="imageUri; else hideImage">
              <img [src]="imageUri" />
            </ng-container>
            <ng-template #hideImage>
              <mat-icon class="hide-image">hide_image</mat-icon>
            </ng-template>
          </div>
        </div>
        <div class="flex-[230px] min-w-[230px] max-w-[230px]">
          <div
            data-at-device-type
            class="device-type"
            [class.active]="sortActive === 'marketingName'"
          >
            <span class="installation-title">{{ installationTitle }}</span>
            <img
              *ngIf="brandLogo && !isMultigatewayInstallation"
              class="ml-2"
              src="{{ brandLogo }}"
            />
          </div>

          <div data-at-installation-type class="installation-type">
            {{
              '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.' +
                installation.installationType.toUpperCase() | translate
            }}
          </div>
        </div>
        <app-operating-mode-indicators
          data-at-operating-modes
          *ngIf="operatingModes$ | async as operatingModes"
          class="operating-mode cell flex-[120px] min-w-[120px] max-w-[120px]"
        >
          <app-operating-mode-indicator
            *ngFor="let circuitId of operatingModes.circuits"
            [operatingMode]="operatingModes?.mode?.[circuitId]"
          ></app-operating-mode-indicator>
          <app-operating-mode-indicator
            *ngIf="operatingModes.isDhw"
            [isDhw]="true"
          ></app-operating-mode-indicator>
        </app-operating-mode-indicators>
      </div>
      <div data-at-serial-number class="owner-name cell flex-[150px] min-w-[150px] max-w-[150px]">
        {{ serial }}
      </div>
      <div
        data-at-owner-name
        class="owner-name cell flex-[180px] min-w-[180px] max-w-[180px]"
        [class.active]="sortActive === 'ownerName'"
      >
        {{ installation.ownerName }}
      </div>
      <div
        data-at-location
        class="location flex-[270px] min-w-[270px] max-w-[270px]"
        [class.active]="sortActive === 'location'"
      >
        {{ installation.location }}
      </div>

      <ng-container *appHideForRsaUser>
        <div data-at-recommendation class="flex-[200px] min-w-[200px] max-w-[200px]">
          <ng-container
            *ngIf="(installationPackage$ | async)?.plan === 'Pro'; else notProInstallations"
          >
            <ng-container *ngIf="showRemoteInspectionRecommendation">
              <ng-container
                *ngIf="
                  remoteInspectionRecommendation$ | async as recommendation;
                  else noRecommendation
                "
              >
                <ng-container
                  *ngIf="
                    isOverwriteSummaryWithErrorMessage(recommendation);
                    then statusErrors;
                    else statusNoErrors
                  "
                ></ng-container>

                <ng-template #statusErrors>
                  <div class="recommendation-status">
                    <app-pill data-at-pro-recommendation [type]="pillType.errorInverted">
                      {{ '+REMOTE_INSPECTION.DASHBOARD_ACTIVE_ERROR' | translate }}
                    </app-pill>
                    {{ '+REMOTE_INSPECTION.DASHBOARD_ACTIVE_ERROR_DETECTED' | translate }}
                  </div>
                </ng-template>

                <ng-template #statusNoErrors>
                  <div class="recommendation-status">
                    <app-pill
                      data-at-pro-recommendation
                      [type]="
                        remoteServiceService.getRiskStatusPillTypeByRiskValue(
                          recommendation?.highestRiskValue
                        )
                      "
                    >
                      {{
                        (recommendation?.highestRiskValue === 0
                          ? '+REMOTE_INSPECTION.DASHBOARD_NO_ANOMALY'
                          : '+REMOTE_INSPECTION.DASHBOARD_ANOMALY_DETECTED'
                        ) | translate
                      }}
                    </app-pill>
                  </div>
                </ng-template>
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-template #noRecommendation>
            <span class="text-pro" data-at-pro-recommendation>{{
              '+REMOTE_SERVICE.NO_ANOMALY_DATA' | translate
            }}</span>
          </ng-template>

          <ng-template #notProInstallations>
            <div
              class="remote-service"
              data-at-upgrade-to-pro
              *ngIf="canShowBuyProEncouragement || (authStore.isDemo$ | async)"
            >
              <span>{{ '+REMOTE_SERVICE.WANT_TO_SEE_MORE' | translate }}</span>
              <span class="text-pro">{{ '+REMOTE_SERVICE.UPGRADE_TO_PRO' | translate }}</span>
            </div>
          </ng-template>
        </div>

        <div data-at-location class="flex-[40px] min-h-[40px] max-h-[40px]">
          <ng-container *ngIf="installationPackage$ | async as package">
            <app-booking-package-badge
              data-at-booked-package
              size="small"
              [packageType]="package.plan"
              [isTrial]="package.isTrial"
            ></app-booking-package-badge>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <app-main-devices-list-large
      class="flex custom-padding"
      *ngIf="isMultigatewayInstallation"
      [installationId]="installation.id"
      [appPreventEvent]="eventNames.MOUSE_DOWN"
    ></app-main-devices-list-large>
  </div>
</a>

<a
  *ngIf="!isTableDesktopView"
  data-at-xs-installation
  class="installation small flex flex-row gap-[25px]"
  [class.border]="isTrialPackageEnding"
  gtm="onGoToPage"
  gtmAction="Installation"
  gtmCategory="installationsOverview"
  [gtmId]="installation.id"
  routerLink="/installations/{{ installation.id }}"
>
  <div class="flex flex-col gap-[33px] flex-[53px] min-w-[53px] max-w-[53px]">
    <div data-at-xs-device-icon class="flex-[80px] min-h-[80px] max-h-[80px] device-icon">
      <div class="flex-1">
        <ng-container *ngIf="imageUri; else hideImage">
          <img [src]="imageUri" />
        </ng-container>
        <ng-template #hideImage>
          <mat-icon class="hide-image">hide_image</mat-icon>
        </ng-template>
      </div>
    </div>

    <div class="flex flex-row flex-[17px] min-h-[17px] max-h-[17px] justify-center items-center">
      <app-installation-item-status
        *ngIf="!isMultigatewayInstallation"
        [liveUpdate]="true"
        [gateway]="installation?.gateways[0]"
        [isColdSystem]="installation.isColdSystem"
      ></app-installation-item-status>

      <mat-icon
        *ngIf="isMultigatewayInstallation && installation.isColdSystem"
        class="cold-system-mode !flex flex-row flex-[20px] min-h-[20px] max-h-[20px] justify-center items-stretch"
        >cancel</mat-icon
      >
    </div>
  </div>
  <div
    [ngClass]="{
      'gap-[0px]': isMultigatewayInstallation,
      'gap-[18px]': !isMultigatewayInstallation
    }"
    class="user-info-wrapper flex flex-col flex-[100%]"
  >
    <div class="flex flex-col gap-[11px]">
      <div class="flex flex-col gap-[6px]">
        <div
          data-at-xs-device-type
          class="device-type xs flex-[19px] min-h-[19px] max-h-[19px] flex"
        >
          <span class="installation-title">{{ installationTitle }}</span>
          <img *ngIf="brandLogo" class="mt-[0px] brand-logo" src="{{ brandLogo }}" />
        </div>
        <div class="flex flex-col sm:flex-row gap-[8px]">
          <div *ngIf="serial" data-at-xs-boiler-serial>{{ serial }}</div>
          <div data-at-installation-type class="installation-type">
            {{
              '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.' +
                installation.installationType.toUpperCase() | translate
            }}
          </div>
        </div>
      </div>
      <div class="flex flex-row">
        <app-operating-mode-indicators
          data-at-xs-operating-modes
          *ngIf="operatingModes$ | async as operatingModes"
          class="operating-mode cell flex-1"
        >
          <app-operating-mode-indicator
            *ngFor="let circuitId of operatingModes.circuits"
            [operatingMode]="operatingModes?.mode?.[circuitId]"
          ></app-operating-mode-indicator>
          <app-operating-mode-indicator
            *ngIf="operatingModes.isDhw"
            [isDhw]="true"
          ></app-operating-mode-indicator>
        </app-operating-mode-indicators>
      </div>
    </div>
    <div class="flex flex-col">
      <app-main-devices-list-small
        *ngIf="isMultigatewayInstallation"
        [installationId]="installation.id"
      ></app-main-devices-list-small>
      <div data-at-xs-owner-name class="owner-name xs">
        {{ installation.ownerName }}
      </div>
      <div data-at-xs-location class="location xs">{{ installation.location }}</div>
      <ng-container *appHideForRsaUser>
        <div data-at-location class="remote-service-status">
          <ng-container
            *ngIf="(installationPackage$ | async)?.plan === 'Pro'; else notProInstallations"
          >
            <ng-container *ngIf="showRemoteInspectionRecommendation">
              <ng-container
                *ngIf="
                  remoteInspectionRecommendation$ | async as recommendation;
                  else noRecommendation
                "
              >
                <ng-container
                  *ngIf="
                    isOverwriteSummaryWithErrorMessage(recommendation);
                    then statusErrors;
                    else statusNoErrors
                  "
                ></ng-container>

                <ng-template #statusErrors>
                  <div class="recommendation-status">
                    <app-pill data-at-pro-recommendation [type]="pillType.errorInverted">
                      {{ '+REMOTE_INSPECTION.DASHBOARD_ACTIVE_ERROR' | translate }}
                    </app-pill>
                    {{ '+REMOTE_INSPECTION.DASHBOARD_ACTIVE_ERROR_DETECTED' | translate }}
                  </div>
                </ng-template>

                <ng-template #statusNoErrors>
                  <div class="recommendation-status">
                    <app-pill
                      data-at-pro-recommendation
                      [type]="
                        remoteServiceService.getRiskStatusPillTypeByRiskValue(
                          recommendation?.highestRiskValue
                        )
                      "
                    >
                      {{
                        (recommendation?.highestRiskValue === 0
                          ? '+REMOTE_INSPECTION.DASHBOARD_NO_ANOMALY'
                          : '+REMOTE_INSPECTION.DASHBOARD_ANOMALY_DETECTED'
                        ) | translate
                      }}
                    </app-pill>
                  </div>
                </ng-template>
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-template #noRecommendation>
            <span class="text-pro" data-at-pro-recommendation>{{
              '+REMOTE_SERVICE.NO_ANOMALY_DATA' | translate
            }}</span>
          </ng-template>

          <ng-template #notProInstallations>
            <div
              class="remote-service"
              data-at-upgrade-to-pro
              *ngIf="canShowBuyProEncouragement || (authStore.isDemo$ | async)"
            >
              <span>{{ '+REMOTE_SERVICE.WANT_TO_SEE_MORE' | translate }}</span>
              <span class="text-pro"
                >{{ '+REMOTE_SERVICE.UPGRADE_TO_PRO' | translate
                }}<mat-icon>chevron_right</mat-icon></span
              >
            </div>
          </ng-template>
        </div>

        <div data-at-location>
          <ng-container *ngIf="installationPackage$ | async as package">
            <app-booking-package-badge
              data-at-booked-package
              class="package-mobile"
              size="small"
              [packageType]="package.plan"
              [isTrial]="package.isTrial"
            ></app-booking-package-badge>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</a>
<div
  *ngIf="isTrialPackageEnding"
  (click)="fetchBookingData()"
  [routerLink]="'/booking'"
  [queryParams]="{ selectedStep: 2, boilerSerial: boilerSerial, update: false }"
>
  <app-banner
    class="banner__wrapper banner__wrapper--link"
    [title]="'+INSTALLATIONS.INSTALLATIONS.TRIAL_WARNING.HEADER' | translate"
    >{{ '+INSTALLATIONS.INSTALLATIONS.TRIAL_WARNING.DESCRIPTION' | translate }}</app-banner
  >
</div>
<ng-container
  *ngrxLet="
    this.installationsStore.getActivePackageExpirationDate(boilerSerial);
    let activePackageExpirationDate
  "
>
  <app-banner
    *ngIf="isContingentPackageEnding"
    class="banner__wrapper"
    [title]="
      '+INSTALLATIONS.INSTALLATIONS.AUTOMATIC_EXTENSION_WARNING.HEADER'
        | translate: { expirationDate: activePackageExpirationDate | date }
    "
    [linkLabel]="'+BOOKING.GO_TO_BOOKING_OVERVIEW' | translate"
    [linkForRouter]="'/booking-overview'"
    linkGtm="onGoToPage"
    linkGtmAction="Open booking overview"
    linkGtmCategory="bookingOverview"
    >{{
      '+INSTALLATIONS.INSTALLATIONS.AUTOMATIC_EXTENSION_WARNING.DESCRIPTION' | translate
    }}</app-banner
  >
</ng-container>
